<h3 class="ui primary header">
  {{ modal.context.title }}
  <i class="link times icon" (click)="modal.deny(undefined)"></i>
</h3>

<div class="content">
  <div
    class="ui basic vertical segment bank-details"
    *ngIf="modal.context.title == 'View Bank Account Details'"
  >
    <h3
      class="ui primary header"
      style="
        padding: 0;
        font-family: Roboto;
        font-size: 16px;
        font-weight: 400;
        line-height: 19px;
      "
    >
      {{ currencyId !== "naira" ? "US Dollar" : (currencyId | titlecase) }}
      Bank Account Details
    </h3>
    <div class="ui divider"></div>
    <div>
      <h2 class="ui sub header">BANK NAME</h2>
      <span>{{
        modal.context.details?.activeBankDetails.bankName ||
          dataToJSON(modal.context.details?.activeBankDetails).bankName
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NUMBER</h2>
      <span>{{
        modal.context.details?.activeBankDetails.bankAccountNumber ||
          dataToJSON(modal.context.details?.activeBankDetails).bankAccountNumber
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NAME</h2>
      <span>{{
        modal.context.details?.activeBankDetails.bankAccountName ||
          dataToJSON(modal.context.details?.activeBankDetails).bankAccountName
      }}</span>
    </div>
    <div *ngIf="currencyId !== 'naira'">
      <div
        *ngIf="
          modal.context.details?.activeBankDetails.routingNumber ||
          dataToJSON(modal.context.details?.activeBankDetails)?.routingNumber
        "
      >
        <h2 class="ui sub header">IBAN/ROUTING NUMBER</h2>
        <span>{{
          modal.context.details?.activeBankDetails.routingNumber ||
            dataToJSON(modal.context.details?.activeBankDetails).routingNumber
        }}</span>
      </div>
      <div
        *ngIf="
          modal.context.details?.activeBankDetails.sortCode ||
          dataToJSON(modal.context.details?.activeBankDetails)?.sortCode
        "
      >
        <h2 class="ui sub header">SWIFT OR SORT CODE</h2>
        <span>{{
          modal.context.details?.activeBankDetails.sortCode ||
            dataToJSON(modal.context.details?.activeBankDetails).sortCode
        }}</span>
      </div>
      <div
        *ngIf="
          modal.context.details?.activeBankDetails.intermediarySortCode ||
          dataToJSON(modal.context.details?.activeBankDetails)
            ?.intermediarySortCode
        "
      >
        <h2 class="ui sub header">INTERMEDIARY BANK SWIFT CODE</h2>
        <span>{{
          modal.context.details?.activeBankDetails.intermediarySortCode ||
            dataToJSON(modal.context.details?.activeBankDetails)
              .intermediarySortCode
        }}</span>
      </div>
      <div
        *ngIf="
          modal.context.details?.activeBankDetails.bankPhysicalAddress ||
          dataToJSON(modal.context.details?.activeBankDetails)
            ?.bankPhysicalAddress
        "
      >
        <h2 class="ui sub header">BANK PHYSICAL ADDRESS</h2>
        <span>{{
          modal.context.details?.activeBankDetails.bankPhysicalAddress ||
            dataToJSON(modal.context.details?.activeBankDetails)
              .bankPhysicalAddress
        }}</span>
      </div>
    </div>
  </div>

  <div
    class="ui basic vertical segment bank-details"
    *ngIf="modal.context.title == 'Transaction Details'"
  >
    <div>
      <h2 class="ui sub header">TRANSACTION ID</h2>
      <span>{{ data?.transactionRef }}</span>
    </div>
    <div>
      <h2 class="ui sub header">DESCRIPTION</h2>
      <span>{{
        data?.transactionTag.toLowerCase().includes("deposit")
          ? "eWallet Deposit"
          : data?.transactionTag.toLowerCase().includes("withdrawal")
          ? "eWallet Withdrawal"
          : data?.transactionTag.toLowerCase().includes("payment")
          ? "Payment"
          : (data?.transactionTag | titlecase)
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">TYPE</h2>
      <span>{{
        data?.transactionTag
          ? (getLastWord(data?.transactionTag) | titlecase)
          : getLastWord(data?.description) || "null"
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">CREDIT</h2>
      <span
        >{{ data?.currencyId == "naira" ? "₦" : "$"
        }}{{ data?.creditAmount | number: "1.2-2" }}</span
      >
    </div>
    <div>
      <h2 class="ui sub header">DEBIT</h2>
      <span
        >{{ data?.currencyId == "naira" ? "₦" : "$"
        }}{{ data?.debitAmount | number: "1.2-2" }}</span
      >
    </div>
    <div>
      <h2 class="ui sub header">TRANSACTION DATE</h2>
      <span>{{ data?.dateCreated | date: "medium" }}</span>
    </div>
    <div>
      <h2 class="ui sub header">STATUS</h2>
      <span
        class="ui green circular label"
        [ngClass]="{
          green: data?.status === 'OKAY',
          red: data?.status !== 'OKAY',
          yellow: data?.status.includes('AWAITING')
        }"
        >{{
          (data?.status == "OKAY" ? "SUCCESSFUL" : data?.status) | uppercase
        }}</span
      >
    </div>
  </div>

  <div
    class="ui basic vertical segment bank-details"
    *ngIf="modal.context.title == 'View Withdrawal Request Details'"
  >
    <h3 class="ui primary header second">Bank Details</h3>
    <div class="ui divider"></div>
    <div>
      <h2 class="ui sub header">BANK NAME</h2>
      <span>{{
        data?.toValue != null
          ? dataToJSON(data?.toValue).bankName
          : ("null" | titlecase)
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NUMBER</h2>
      <span>{{
        data?.toValue != null
          ? dataToJSON(data?.toValue).bankAccountNumber
          : "null"
      }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NAME</h2>
      <span>{{
        data?.toValue != null
          ? dataToJSON(data?.toValue).bankAccountName
          : ("null" | titlecase)
      }}</span>
    </div>

    <h3 class="ui primary header second">Transaction Details</h3>
    <div class="ui divider"></div>
    <div>
      <h2 class="ui sub header">eWallet TYPE</h2>
      <span
        >{{
          (data?.currencyName || currencyId == "naira" ? "naira" : "dollar")
            | titlecase
        }}
        Wallet</span
      >
    </div>
    <div>
      <h2 class="ui sub header">TRANSACTION ID</h2>
      <span>{{ data?.transactionId || "null" }}</span>
    </div>
    <div>
      <h2 class="ui sub header">AMOUNT</h2>
      <span
        >{{ data?.currencyCode || currencyId == "naira" ? "₦" : "$" }}
        {{ data?.amount | number: "1.2-2" }}</span
      >
    </div>
    <div>
      <h2 class="ui sub header">CHARGES</h2>
      <span
        >{{ data?.currencyCode || currencyId == "naira" ? "₦" : "$" }}
        {{ data?.totalCharges | number: "1.2-2" }}</span
      >
    </div>
    <div>
      <h2 class="ui sub header">TRANSACTION DATE</h2>
      <span>{{ data?.dateCreated | date: "medium" }}</span>
    </div>
    <div *ngIf="data?.status == 'APPROVED'">
      <h2 class="ui sub header">APPROVED BY</h2>
      <span>{{ dataToJSON(dataToJSON(data.approvalBy).approvedBy).name }}</span>
    </div>
    <div *ngIf="data?.status == 'APPROVED'">
      <h2 class="ui sub header">DATE APPROVED</h2>
      <span>{{ data?.approvalDate | date: "medium" }}</span>
    </div>
    <div *ngIf="data?.status == 'REJECTED'">
      <h2 class="ui sub header">REJECTED BY</h2>
      <span>{{ dataToJSON(dataToJSON(data.approvalBy).rejectedBy).name }}</span>
    </div>
    <div>
      <h2 class="ui sub header">STATUS</h2>
      <span
        class="ui circular label"
        [ngClass]="{
          green: data?.status === 'APPROVED',
          red: data?.status === 'CANCELLED',
          yellow:
            data?.status === 'PENDING' ||
            data?.status.toLowerCase().includes('ongoing')
        }"
        >{{
          (data?.status.toLowerCase().includes("ongoing")
            ? "PENDING"
            : data?.status
          ) | uppercase
        }}</span
      >
    </div>

    <ng-container *ngIf="documents && documents.length > 0">
      <h3 class="ui primary header second">Transaction Document</h3>
      <div class="ui divider"></div>
      <div *ngFor="let document of documents" class="document-box">
        <div class="document-file">
          <div class="icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M16.25 12.751V10.5635C16.25 9.01018 14.9908 7.75098 13.4375 7.75098H12.1875C11.6697 7.75098 11.25 7.33124 11.25 6.81348V5.56348C11.25 4.01018 9.9908 2.75098 8.4375 2.75098H6.875M6.875 13.376H13.125M6.875 15.876H10M8.75 2.75098H4.6875C4.16973 2.75098 3.75 3.17071 3.75 3.68848V18.0635C3.75 18.5812 4.16973 19.001 4.6875 19.001H15.3125C15.8303 19.001 16.25 18.5812 16.25 18.0635V10.251C16.25 6.10884 12.8921 2.75098 8.75 2.75098Z"
                stroke="#202223"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
          <span class="document-name">{{ document.documentName }}</span>
        </div>
        <a [href]="secureDocumentUrl" target="_blank">
          <button class="view-btn clickable" (click)="viewDocument(document)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="21"
              viewBox="0 0 20 21"
              fill="none"
            >
              <path
                d="M1.69556 11.1446C1.63799 10.9719 1.63794 10.7849 1.6954 10.6122C2.85237 7.13408 6.13326 4.62598 9.99994 4.62598C13.8648 4.62598 17.1445 7.13175 18.3029 10.6073C18.3604 10.78 18.3605 10.967 18.303 11.1398C17.1461 14.6179 13.8652 17.126 9.99848 17.126C6.1336 17.126 2.85397 14.6202 1.69556 11.1446Z"
                stroke="#0F172A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.4993 10.876C12.4993 12.2567 11.38 13.376 9.99927 13.376C8.61856 13.376 7.49927 12.2567 7.49927 10.876C7.49927 9.49526 8.61856 8.37598 9.99927 8.37598C11.38 8.37598 12.4993 9.49526 12.4993 10.876Z"
                stroke="#0F172A"
                stroke-width="1.5"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </a>
      </div>
    </ng-container>
  </div>

  <div
    class="ui basic vertical segment bank-details"
    *ngIf="modal.context.title == 'View Change of Bank Details Request'"
  >
    <div>
      <h2 class="ui sub header">BANK NAME</h2>
      <span>{{ dataToJSON(data.toValue).bankName | titlecase }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NUMBER</h2>
      <span>{{ dataToJSON(data.toValue).bankAccountNumber }}</span>
    </div>
    <div>
      <h2 class="ui sub header">BANK ACCOUNT NAME</h2>
      <span>{{ dataToJSON(data.toValue).bankAccountName | titlecase }}</span>
    </div>
    <div *ngIf="currencyId !== 'naira'">
      <div *ngIf="dataToJSON(data.toValue)?.routingNumber">
        <h2 class="ui sub header">IBAN/ROUTING NUMBER</h2>
        <span>{{ dataToJSON(data.toValue).routingNumber }}</span>
      </div>
      <div *ngIf="dataToJSON(data.toValue)?.sortCode">
        <h2 class="ui sub header">SWIFT OR SORT CODE</h2>
        <span>{{ dataToJSON(data.toValue).sortCode }}</span>
      </div>
      <div *ngIf="dataToJSON(data.toValue)?.intermediarySortCode">
        <h2 class="ui sub header">INTERMEDIARY BANK SWIFT CODE</h2>
        <span>{{ dataToJSON(data.toValue).intermediarySortCode }}</span>
      </div>
      <div *ngIf="dataToJSON(data.toValue)?.bankPhysicalAddress">
        <h2 class="ui sub header">BANK PHYSICAL ADDRESS</h2>
        <span>{{ dataToJSON(data.toValue).bankPhysicalAddress }}</span>
      </div>
    </div>
    <div>
      <h2 class="ui sub header">CREATED BY</h2>
      <span>{{ dataToJSON(data.createdBy).name }}</span>
    </div>
    <div>
      <h2 class="ui sub header">DATE CREATED</h2>
      <span>{{ data?.dateCreated | date: "medium" }}</span>
    </div>
    <div *ngIf="data?.status == 'APPROVED'">
      <h2 class="ui sub header">APPROVED BY</h2>
      <span>{{ dataToJSON(data.approvalBy).name }}</span>
    </div>
    <div *ngIf="data?.status == 'APPROVED'">
      <h2 class="ui sub header">DATE APPROVED</h2>
      <span>{{ data?.approvalDate | date: "medium" }}</span>
    </div>
    <div>
      <h2 class="ui sub header">STATUS</h2>
      <span
        class="ui circular label"
        [ngClass]="{
          green: data?.status === 'APPROVED',
          red: data?.status === 'REJECTED',
          yellow:
            data?.status === 'PENDING' ||
            data?.status.toLowerCase().includes('ongoing')
        }"
        >{{
          (data?.status.toLowerCase().includes("ongoing")
            ? "PENDING"
            : data?.status
          ) | uppercase
        }}</span
      >
    </div>
  </div>

  <div class="actions" style="border: none">
    <button class="ui basic primary button" (click)="modal.deny(undefined)">
      Back
    </button>
  </div>
</div>
